<div class="main-container-position">
  <div class="container-width">
    <div class="py-8">
      <div class="flex items-center space-x-2 mb-6">
        <button
          (click)="goBack()"
          class="flex items-center text-gray-600 hover:text-gray-900"
          >
          <mat-icon class="mr-1">arrow_back</mat-icon>
          <span i18n>Zurück</span>
        </button>
      </div>

      <h1>Feedback-Historie</h1>
      <p>
        {{ offer?.name }}
      </p>

      <table
        mat-table
        [dataSource]="history"
        multiTemplateDataRows
        class="w-full"
        >
        <!-- Status Column -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let element">
            <div
              [ngClass]="getBadgeColor(element)"
              class="text-white text-xs font-semibold px-2 py-1 rounded-full text-center max-w-[200px]"
              >
              {{ getBadgeText(element) }}
            </div>
          </td>
        </ng-container>

        <!-- Date Column -->
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef>Datum</th>
          <td mat-cell *matCellDef="let element" class="text-sm">
            {{ element.changedAtDate | date : "dd.MM.yyyy HH:mm" }}
          </td>
        </ng-container>

        <!-- Comment Column -->
        <ng-container matColumnDef="comment">
          <th mat-header-cell *matHeaderCellDef>Kommentar</th>
          <td mat-cell *matCellDef="let element" class="text-sm">
            {{ element.comment }}
          </td>
        </ng-container>

        <!-- Expand Column -->
        <ng-container matColumnDef="expand">
          <th mat-header-cell *matHeaderCellDef aria-label="expand row"></th>
          <td mat-cell *matCellDef="let element">
            <button
              mat-icon-button
              aria-label="expand row"
              [style.visibility]="isExpandable(element) ? 'visible' : 'hidden'"
              (click)="expandRow(element)"
              >
              <mat-icon (click)="expandRow(element)">{{
                expandedElement === element ? "expand_less" : "expand_more"
              }}</mat-icon>
            </button>
          </td>
        </ng-container>

        <!-- Expanded Content Column -->
        <ng-container matColumnDef="expandedDetail">
          <td
            mat-cell
            *matCellDef="let element"
            [attr.colspan]="displayedColumns.length"
            >
            <div
              class="element-detail"
              [@detailExpand]="
                element === expandedElement ? 'expanded' : 'collapsed'
              "
              >
              <!-- Feedback Content -->
              @if (isExpandable(element)) {
                <div class="p-4">
                  <app-feedback-details
                    [feedback]="element.convertedFeedback"
                    [categories]="categories"
                    [offerTypes]="types"
                  ></app-feedback-details>
                </div>
              }
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let element; columns: displayedColumns"
          class="element-row"
          [class.expanded-row]="expandedElement === element"
          (click)="expandRow(element)"
          [class.cursor-pointer]="isExpandable(element)"
          [class.cursor-not-allowed]="!isExpandable(element)"
        ></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: ['expandedDetail']"
          class="detail-row"
        ></tr>
      </table>
    </div>
  </div>
</div>
